// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b8db762d","455":"2588c9d6","879":"925f5ef3"}[chunkId] + ".chunk.js";
};